export default __webpack_public_path__ + "static/media/video_file.c5146e69.svg";